import MultiSelect from '../_classes/MultiSelect';

export function initMultiSelect ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);
		if (!($el instanceof MultiSelect)) {
			const instance = new MultiSelect($el);
			instance.init();
		}
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/multi-select.js